export default class RaioAtuacaoModel {
    public Distancia: number = 0;
    public ValorMinimo: number = 0;

    public static toModelList(obj: any): RaioAtuacaoModel[] {
        return obj ? obj.map((item: any) => {
            return {
                Distancia: item.Distance,
                ValorMinimo: item.MinValue
            } as RaioAtuacaoModel;
        }) : [];
    }
}